import axios from 'axios';
const baseUrl = process.env.REACT_APP_APP_BACK_URL + '/api';
const axiosConfig = {
    baseURL: baseUrl,
    headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": "true",
        "auth-token": localStorage.getItem("token")
    }
}
const AXIOS = axios.create(axiosConfig)
AXIOS.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers['auth-token'] = `${token}`;
    }
    return config
})
export default AXIOS;